import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Human-friendly relative time: "now", "3m", "2h", "Jan 5" */
export function timeAgo(iso: string): string {
  try {
    const d = new Date(iso)
    const diffMs = Date.now() - d.getTime()
    const diffMin = Math.floor(diffMs / 60000)
    if (diffMin < 1) return "now"
    if (diffMin < 60) return `${diffMin}m`
    const diffHr = Math.floor(diffMin / 60)
    if (diffHr < 24) return `${diffHr}h`
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric" })
  } catch { return "" }
}

/** Format veto countdown: "3:42" or "ready" */
export function fmtCountdown(secs: number): string {
  if (secs <= 0) return "ready"
  const m = Math.floor(secs / 60)
  const s = Math.round(secs % 60)
  return `${m}:${String(s).padStart(2, "0")}`
}
